import { usePublicUserProfileQuery } from 'codegen/generated/user'

export function useUserTypeQuery({ userSlug }: { userSlug: string }) {
  return usePublicUserProfileQuery(
    { slug: userSlug },
    {
      select: data => {
        const userProfile = data?.publicUserProfile
        const type: 'verified' | 'premium' | 'both' | undefined =
          // oxlint-disable-next-line no-nested-ternary
          userProfile?.isVerified && userProfile?.isPremium
            ? 'both'
            : // oxlint-disable-next-line no-nested-ternary
              userProfile?.isVerified
              ? 'verified'
              : // oxlint-disable-next-line unicorn/no-nested-ternary
                userProfile?.isPremium
                ? 'premium'
                : undefined
        return type
      },
    },
  )
}
